const DocumentationPage = () => import(/* webpackChunkName: "docs" */'@/modules/Docs/containers/DocumentationPage');

export default {
  path: '/docs/:page',
  name: 'docs',
  component: DocumentationPage,
};



// WEBPACK FOOTER //
// ./src/modules/Docs/routes.js